import React from 'react';
import { Comment, CommentItem, RemixComment } from 'types/comment';
import { CommunityShotItem } from 'types/community';
import CommentGroup from './CommentGroup';
import styles from './CommentList.module.css';

type Props = {
  commentItems: CommentItem[];
  shotItem: CommunityShotItem;
  targetCommentId?: number;
};

export default function CommentList(props: Props) {
  return (
    <div className={styles.CommentList}>
      {props.commentItems.map((commentItem) => {
        const key =
          commentItem.type === 'COMMENT'
            ? `comment${(commentItem.item as Comment).commentId}`
            : `remix${(commentItem.item as RemixComment).communityRevisionId}`;

        return (
          <CommentGroup
            key={key}
            commentItem={commentItem}
            shotItem={props.shotItem}
            repliesEnabled={true}
            targetCommentId={props.targetCommentId}
          />
        );
      })}
    </div>
  );
}
